import VSLRow from "./VSLRow";

export default class VSLImageGalleryRow extends VSLRow {

    constructor(id, imagesUrls) {
        super(id, "images");

        this.imagesUrls = imagesUrls
    }
}